module.exports = __webpack_public_path__ + "img/report-sample-12@3x.93c6b1ab.png";